"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M17.5 7.121a.5.5 0 0 1 .5.5v6.5h3.5c1.378 0 2.5 1.122 2.5 2.5v2c0 1.379-1.122 2.5-2.5 2.5h-19a2.503 2.503 0 0 1-2.5-2.5v-2c0-1.378 1.122-2.5 2.5-2.5H17v-6.5a.5.5 0 0 1 .5-.5Zm4 8h-19c-.827 0-1.5.673-1.5 1.5v2c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-2c0-.827-.673-1.5-1.5-1.5Zm-18 1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm8 .5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5ZM13.61 3.026a.5.5 0 0 1 0 .707 5.505 5.505 0 0 0 0 7.778.5.5 0 0 1-.707.707 6.508 6.508 0 0 1 0-9.192.5.5 0 0 1 .707 0Zm8.486 0a6.508 6.508 0 0 1 0 9.192.498.498 0 0 1-.707 0 .5.5 0 0 1 0-.707 5.505 5.505 0 0 0 0-7.778.5.5 0 0 1 .707-.707ZM15.024 4.44a.5.5 0 0 1 0 .707 3.505 3.505 0 0 0 0 4.95.5.5 0 0 1-.707.707 4.506 4.506 0 0 1 0-6.364.5.5 0 0 1 .707 0Zm5.658 0a4.506 4.506 0 0 1 0 6.364.5.5 0 0 1-.707-.707 3.505 3.505 0 0 0 0-4.95.5.5 0 0 1 .707-.707Zm-4.243 1.413a.5.5 0 0 1 0 .707c-.283.284-.439.66-.439 1.061 0 .401.156.777.439 1.061a.5.5 0 0 1-.707.707A2.484 2.484 0 0 1 15 7.621c0-.668.26-1.296.732-1.768a.5.5 0 0 1 .707 0Zm2.829 0c.472.472.732 1.1.732 1.768 0 .668-.26 1.296-.732 1.768a.498.498 0 0 1-.708 0 .5.5 0 0 1 0-.707c.284-.283.44-.66.44-1.061 0-.401-.156-.777-.439-1.061a.5.5 0 0 1 .707-.707Z",
    clipRule: "evenodd"
  })]
});